export default "__VITE_ASSET__CM_8XjQ7__"